import { ActionLink } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"

import styles from "../Onboarding.module.scss"
import { OnboardingPageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"
import { GlucoseUnits } from "src/pages/Account/AccountDetails/GlucoseUnits"

const prefix = "pages.onboarding.units_of_measure."

export function UnitsOfMeasure() {
  const polyglot = usePolyglot()

  return (
    <OnboardingPageTemplate
      title={polyglot.t(`${prefix}title`)}
      hideUserName
    >
      <div className={styles.container}>
        <div className={styles.subtitle}>
          {polyglot.t(`${prefix}subtitle`)}
        </div>
        <GlucoseUnits />
        <ActionLink
          asChild
          className={styles.submitCta}
        >
          <Link
            to="/onboarding/get_started"
            id="next-btn"
          >
            {polyglot.t(`${prefix}next_cta`)}
          </Link>
        </ActionLink>
      </div>
    </OnboardingPageTemplate>
  )
}
